import _defineProperty from "@babel/runtime/helpers/defineProperty";
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import CommonPropTypes from "../../../../../common/constants/proptypes/CommonPropTypes";
import AddonDiscoveryPropTypes from "../../../../constants/proptypes/AddonDiscoveryPropTypes";
import CurrentFilters from "./CurrentFilters";
import Stats from "./Stats";
export default class StatsAndCurrentFilters extends Component {
  render() {
    const mediumScreenClass = this.props.screenClass === 'md';
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Stats, {
      filters: this.props.filters,
      numberOfHits: this.props.numberOfHits
    }), /*#__PURE__*/React.createElement("span", null, " "), !mediumScreenClass && /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(CurrentFilters, {
      filters: this.props.filters,
      hiddenFilters: this.props.hiddenFilters,
      stateChangeRequested: this.props.stateChangeRequested
    })));
  }
}
_defineProperty(StatsAndCurrentFilters, "propTypes", {
  filters: CommonPropTypes.filters.isRequired,
  hiddenFilters: AddonDiscoveryPropTypes.hiddenFilters.isRequired,
  numberOfHits: PropTypes.number.isRequired,
  screenClass: CommonPropTypes.screenClass.isRequired,
  stateChangeRequested: PropTypes.func.isRequired
});